import { IonButtons, IonCard, IonItem, IonLabel } from "@ionic/react";
import { useSelector } from "react-redux";
import { DocumentStakeholderNotify } from "../../../components/Document/DocumentStakeholderNotify";
import UserAvatar from "../../../components/UserAvatar";
import { selectDocumentStatus } from "../../../store/documentSupervisorShow/selectors/selectDocumentStatus";
import { selectSigners } from "../../../store/documentSupervisorShow/selectors/selectSigners";

export const DocumentSigners: React.FC = () => {
  const signers = useSelector(selectSigners);
  const status = useSelector(selectDocumentStatus);
  const firstPendingStakeholder = signers.find(({ status }) => status?.code === "pending");

  return (
    <section style={{ maxWidth: "900px" }}>
      <section className="ion-margin-vertical ion-padding-horizontal">
        <h5 style={{ flex: 1, margin: "auto" }}>{signers.length} firmantes</h5>
      </section>

      {signers.length === 0 && (
        <p className="ion-text-center" style={{ fontWeight: 300 }}>
          Este documento no tiene firmantes aún.
        </p>
      )}

      {signers.map((documentStakeholder, index) => (
        <IonCard key={documentStakeholder.stakeholder?.id}>
          <IonItem lines="none">
            <UserAvatar user={documentStakeholder.stakeholder}></UserAvatar>
            <IonLabel>
              <h2 style={{ fontWeight: 500 }}>{documentStakeholder.stakeholder?.name}</h2>
              <p>{documentStakeholder.status?.name}</p>
            </IonLabel>

            <IonButtons slot="end">
              {status?.code === "pending" &&
                firstPendingStakeholder?.id === documentStakeholder.id && (
                  <DocumentStakeholderNotify documentStakeholder={documentStakeholder} />
                )}
            </IonButtons>
          </IonItem>
        </IonCard>
      ))}
    </section>
  );
};
